// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./FieldErrorTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable property-disallowed-list -- DS Component */

.FieldError-module__Container__htbly {
    display: flex;
    gap: var(--ds-xs);
    align-items: center;
    width: 100%;
    padding: var(--ds-xs);
}

.FieldError-module__IconContainer___DGC6 {
    display: flex;
    align-items: center;
    justify-content: center;
}

.FieldError-module__Icon__bRjHq {
    color: var(--ds-field-error-color);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `FieldError-module__Container__htbly`,
	"IconContainer": `FieldError-module__IconContainer___DGC6`,
	"Icon": `FieldError-module__Icon__bRjHq`
};
export default ___CSS_LOADER_EXPORT___;
